import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import pluralize from 'pluralize';
import { pickBy, chain } from 'lodash';
import MySelect from '@/components/MySelect.vue';
let CharacterBuilderSpeciesAbilities = class CharacterBuilderSpeciesAbilities extends Vue {
    constructor() {
        super(...arguments);
        this.abilities = ['Strength', 'Dexterity', 'Constitution', 'Intelligence', 'Wisdom', 'Charisma'];
    }
    get abilitiesIncreasedOptions() {
        // Hardcoded because human is the only race with this option.
        // Otherwise, we will need to construct a string describing the abilityScoreImprovement array
        return [
            { text: 'Any one increases by 2, and any two increase by 1', value: 0 },
            { text: 'Any four increase by 1', value: 1 }
        ];
    }
    get improvementOptions() {
        return this.abilitiesIncreased[this.currentSpecies.abilityScoreImprovementSelectedOption].map(abilityOption => {
            let max = this.getMaxAbilities(abilityOption);
            let choiceList = this.abilities;
            if (abilityOption.abilities.length > 1) {
                choiceList = abilityOption.abilities;
                max = 1;
            }
            const usedAbilities = Object.keys(this.getOtherImprovements(abilityOption.amount));
            const selectedImprovements = this.getImprovementsByAmount(abilityOption.amount, max > 1);
            const isAtMax = max > 1 && selectedImprovements.length >= max;
            const choices = choiceList.map(choice => ({
                text: choice,
                disabled: usedAbilities.includes(choice) || (isAtMax && !selectedImprovements.includes(choice))
            }));
            return {
                ...abilityOption,
                max,
                choices,
                label: `Choose ${max} ability ${pluralize('score', max)} to increase by ${abilityOption.amount}`
            };
        }).filter(({ max }) => max);
    }
    getMaxAbilities(abilityOption) {
        switch (abilityOption.abilities[0]) {
            case 'Any one':
                return 1;
            case 'Any two':
                return 2;
            case 'Any four':
                return 4;
            default:
                return 0;
        }
    }
    getImprovementsByAmount(amount, isMultiple) {
        const abilitiesList = chain(this.currentSpecies.abilityScoreImprovement)
            .pickBy(increase => increase === amount)
            .keys()
            .value();
        return isMultiple ? abilitiesList : abilitiesList[0];
    }
    getOtherImprovements(amount) {
        return pickBy(this.currentSpecies.abilityScoreImprovement, increase => increase !== amount);
    }
    handleChangeOption(option) {
        this.$emit('replaceCharacterProperty', {
            path: 'species',
            property: {
                ...this.currentSpecies,
                abilityScoreImprovementSelectedOption: option,
                abilityScoreImprovement: {}
            }
        });
    }
    handleChangeAbility(amount, ability) {
        const newImprovements = Array.isArray(ability)
            ? chain(ability).keyBy().mapValues(ability => amount).value()
            : { [ability]: amount };
        this.$emit('replaceCharacterProperty', {
            path: 'species.abilityScoreImprovement',
            property: {
                ...this.getOtherImprovements(amount),
                ...newImprovements
            }
        });
    }
};
__decorate([
    Prop(Object)
], CharacterBuilderSpeciesAbilities.prototype, "currentSpecies", void 0);
__decorate([
    Prop(Array)
], CharacterBuilderSpeciesAbilities.prototype, "abilitiesIncreased", void 0);
CharacterBuilderSpeciesAbilities = __decorate([
    Component({
        components: {
            MySelect
        }
    })
], CharacterBuilderSpeciesAbilities);
export default CharacterBuilderSpeciesAbilities;
